import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { SectionHeading } from '../components/ui/SectionHeading';
import { motion } from 'framer-motion';
import { MapPin, Calendar, Users, Globe, Mountain, Heart, Compass, ArrowRight, Check } from 'lucide-react';
const topAttractions = [{
  name: 'Mount Everest',
  desc: "The world's highest peak at 8,849m, visible from Kala Patthar and EBC",
  image: 'https://images.unsplash.com/photo-1533130061792-649d45df8c2d?q=80&w=1978&auto=format&fit=crop'
}, {
  name: 'Kathmandu Valley',
  desc: 'UNESCO World Heritage sites including Durbar Squares and ancient temples',
  image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Pokhara',
  desc: 'Gateway to Annapurna, stunning lakes, and adventure sports paradise',
  image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?q=80&w=1933&auto=format&fit=crop'
}, {
  name: 'Chitwan National Park',
  desc: 'Wildlife safari, Bengal tigers, one-horned rhinos, and jungle adventures',
  image: 'https://images.unsplash.com/photo-1564760055775-d63b17a55c44?q=80&w=2076&auto=format&fit=crop'
}];
const popularTreks = [{
  title: 'Everest Base Camp',
  duration: '14 Days',
  difficulty: 'Challenging',
  price: '$1,450',
  image: 'https://images.unsplash.com/photo-1533130061792-649d45df8c2d?q=80&w=1978&auto=format&fit=crop',
  link: 'https://project-everest-base-camp-trek-detail-page-148.magicpatterns.app/'
}, {
  title: 'Annapurna Circuit',
  duration: '16 Days',
  difficulty: 'Moderate',
  price: '$1,250',
  image: 'https://images.unsplash.com/photo-1548588627-f978862b85e1?q=80&w=2072&auto=format&fit=crop',
  link: '#'
}, {
  title: 'Langtang Valley',
  duration: '9 Days',
  difficulty: 'Moderate',
  price: '$950',
  image: 'https://images.unsplash.com/photo-1623492701902-47d3be136e96?q=80&w=2070&auto=format&fit=crop',
  link: '#'
}];
const practicalInfo = [{
  label: 'Visa',
  value: 'On arrival - $30-50 USD',
  icon: Globe
}, {
  label: 'Currency',
  value: 'Nepalese Rupee (NPR)',
  icon: Globe
}, {
  label: 'Best Time',
  value: 'March-May, Sept-Nov',
  icon: Calendar
}, {
  label: 'Language',
  value: 'Nepali, English widely spoken',
  icon: Users
}];
export function DestinationNepalPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-990">
      <Navbar data-id="element-991" />

      {/* Hero Section */}
      <div className="relative h-[70vh] min-h-[600px] flex items-end overflow-hidden" data-id="element-992">
        <div className="absolute inset-0 z-0" data-id="element-993">
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent z-10" data-id="element-994" />
          <img src="https://images.unsplash.com/photo-1544735716-392fe2489ffa?q=80&w=2071&auto=format&fit=crop" alt="Nepal Mountains" className="w-full h-full object-cover" data-id="element-995" />
        </div>

        <div className="relative z-20 w-full px-4 pb-16 mt-16" data-id="element-996">
          <div className="max-w-7xl mx-auto" data-id="element-997">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} data-id="element-998">
              <div className="flex items-center gap-2 mb-4" data-id="element-999">
                <MapPin className="text-[#06B6D4]" size={24} data-id="element-1000" />
                <span className="text-white/90 font-medium text-lg" data-id="element-1001">
                  South Asia • Himalayas
                </span>
              </div>
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6" data-id="element-1002">
                Nepal
              </h1>
              <p className="text-2xl text-gray-200 max-w-3xl mb-8 leading-relaxed" data-id="element-1003">
                Home to eight of the world's fourteen highest peaks, ancient
                temples, and the warmest people on Earth. Nepal is where
                adventure meets spirituality.
              </p>

              <div className="flex flex-wrap gap-6 text-white" data-id="element-1004">
                <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-1005">
                  <Mountain size={24} className="text-[#06B6D4]" data-id="element-1006" />
                  <div data-id="element-1007">
                    <p className="text-xs text-gray-300" data-id="element-1008">Highest Peak</p>
                    <p className="font-bold" data-id="element-1009">Mt. Everest (8,849m)</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-1010">
                  <Heart size={24} className="text-[#06B6D4]" data-id="element-1011" />
                  <div data-id="element-1012">
                    <p className="text-xs text-gray-300" data-id="element-1013">Population</p>
                    <p className="font-bold" data-id="element-1014">30 Million</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-1015">
                  <Compass size={24} className="text-[#06B6D4]" data-id="element-1016" />
                  <div data-id="element-1017">
                    <p className="text-xs text-gray-300" data-id="element-1018">Capital</p>
                    <p className="font-bold" data-id="element-1019">Kathmandu</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-1020">
        {/* Overview Section */}
        <section className="mb-20" data-id="element-1021">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1022">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-1023">
              <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-1024">
                Discover the Roof of the World
              </h2>
              <div className="prose prose-lg text-gray-700 space-y-4" data-id="element-1025">
                <p data-id="element-1026">
                  Nepal is a landlocked country nestled in the heart of the
                  Himalayas, bordered by China to the north and India to the
                  south. Despite its small size, Nepal boasts incredible
                  geographic diversity—from the steamy jungles of the Terai to
                  the frozen peaks of the Himalayas.
                </p>
                <p data-id="element-1027">
                  This is a land where ancient traditions thrive alongside
                  modern aspirations. Prayer flags flutter in mountain winds,
                  monks chant in centuries-old monasteries, and the spirit of
                  adventure draws travelers from every corner of the globe.
                </p>
                <p data-id="element-1028">
                  Whether you're trekking to Everest Base Camp, exploring the
                  medieval cities of Kathmandu Valley, or seeking spiritual
                  enlightenment in Lumbini (birthplace of Buddha), Nepal offers
                  experiences that transform lives.
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="relative" data-id="element-1029">
              <div className="absolute -inset-4 bg-gradient-to-r from-[#0066FF] to-[#06B6D4] rounded-2xl opacity-20 blur-xl" data-id="element-1030"></div>
              <img src="https://images.unsplash.com/photo-1589553416260-f586c8f1514f?q=80&w=2070&auto=format&fit=crop" alt="Nepal Culture" className="relative rounded-2xl shadow-2xl w-full h-auto object-cover" data-id="element-1031" />
            </motion.div>
          </div>
        </section>

        {/* Best Time to Visit */}
        <section className="mb-20 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 md:p-12" data-id="element-1032">
          <SectionHeading title="Best Time to Visit" subtitle="Plan your trip around Nepal's distinct seasons." centered={false} data-id="element-1033" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-1034">
            <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-1035">
              <div className="flex items-center gap-3 mb-4" data-id="element-1036">
                <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center" data-id="element-1037">
                  <Calendar size={24} data-id="element-1038" />
                </div>
                <div data-id="element-1039">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-1040">
                    Spring (March - May)
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1041">Peak Trekking Season</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-1042">
                Clear skies, blooming rhododendrons, and stable weather make
                this the most popular time for trekking. Temperatures are mild
                at lower elevations, though it can still be cold at high
                altitude. Expect crowds on popular routes.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-1043">
              <div className="flex items-center gap-3 mb-4" data-id="element-1044">
                <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center" data-id="element-1045">
                  <Calendar size={24} data-id="element-1046" />
                </div>
                <div data-id="element-1047">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-1048">
                    Autumn (Sept - Nov)
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1049">Best Mountain Views</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-1050">
                Post-monsoon clarity offers the best mountain views of the year.
                Crisp air, comfortable temperatures, and festive celebrations
                (Dashain, Tihar) create magical experiences. Another peak season
                with high trail traffic.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-1051">
              <div className="flex items-center gap-3 mb-4" data-id="element-1052">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center" data-id="element-1053">
                  <Calendar size={24} data-id="element-1054" />
                </div>
                <div data-id="element-1055">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-1056">
                    Winter (Dec - Feb)
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1057">Quiet Trails</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-1058">
                Cold temperatures and snow at high passes, but lower elevations
                remain pleasant. Fewer trekkers mean peaceful trails and better
                lodge availability. Best for low-altitude treks and cultural
                tours.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md" data-id="element-1059">
              <div className="flex items-center gap-3 mb-4" data-id="element-1060">
                <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center" data-id="element-1061">
                  <Calendar size={24} data-id="element-1062" />
                </div>
                <div data-id="element-1063">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-1064">
                    Monsoon (June - Aug)
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1065">Off Season</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-1066">
                Heavy rainfall makes trails muddy and leeches common. Mountain
                views are often obscured by clouds. However, rain-shadow areas
                like Upper Mustang and Dolpo are ideal during this period.
              </p>
            </div>
          </div>
        </section>

        {/* Top Attractions */}
        <section className="mb-20" data-id="element-1067">
          <SectionHeading title="Must-Visit Attractions" subtitle="Iconic destinations that define Nepal." data-id="element-1068" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1069">
            {topAttractions.map((attraction, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow" data-id="element-1070">
                <div className="relative h-80 overflow-hidden" data-id="element-1071">
                  <img src={attraction.image} alt={attraction.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-1072" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" data-id="element-1073" />
                  <div className="absolute bottom-0 left-0 p-6 w-full" data-id="element-1074">
                    <h3 className="text-2xl font-bold text-white mb-2" data-id="element-1075">
                      {attraction.name}
                    </h3>
                    <p className="text-gray-200" data-id="element-1076">{attraction.desc}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Culture Section */}
        <section className="mb-20" data-id="element-1077">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1078">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="order-2 lg:order-1" data-id="element-1079">
              <img src="https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=2076&auto=format&fit=crop" alt="Nepal Culture" className="rounded-2xl shadow-xl w-full h-auto object-cover" data-id="element-1080" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="order-1 lg:order-2" data-id="element-1081">
              <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-1082">
                Rich Culture & Warm People
              </h2>
              <div className="prose prose-lg text-gray-700 space-y-4" data-id="element-1083">
                <p data-id="element-1084">
                  Nepal is a melting pot of cultures, religions, and
                  ethnicities. Hinduism and Buddhism coexist harmoniously,
                  creating a unique spiritual atmosphere found nowhere else on
                  Earth.
                </p>
                <p data-id="element-1085">
                  The Sherpa people of the Khumbu region are world-renowned for
                  their mountaineering prowess and warm hospitality. Their
                  Buddhist traditions, colorful festivals, and strong community
                  bonds create unforgettable cultural experiences for visitors.
                </p>
                <p data-id="element-1086">
                  From the Newari artisans of Kathmandu Valley to the Thakali
                  traders of the Annapurna region, each ethnic group contributes
                  to Nepal's rich cultural tapestry. Visitors are welcomed with
                  "Namaste" and treated like family.
                </p>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Practical Information */}
        <section className="mb-20 bg-gray-50 rounded-2xl p-8 md:p-12" data-id="element-1087">
          <SectionHeading title="Practical Information" subtitle="Everything you need to know before you go." centered={false} data-id="element-1088" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8" data-id="element-1089">
            {practicalInfo.map((info, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-6 rounded-xl shadow-md" data-id="element-1090">
                <div className="w-12 h-12 bg-blue-100 text-[#0066FF] rounded-lg flex items-center justify-center mb-4" data-id="element-1091">
                  <info.icon size={24} data-id="element-1092" />
                </div>
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-1093">{info.label}</h4>
                <p className="text-gray-600 text-sm" data-id="element-1094">{info.value}</p>
              </motion.div>)}
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1095">
            <div className="bg-white p-6 rounded-xl" data-id="element-1096">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1097">
                <Check className="text-green-600" size={20} data-id="element-1098" />
                Essential Tips
              </h4>
              <ul className="space-y-2 text-gray-700 text-sm" data-id="element-1099">
                <li className="flex items-start gap-2" data-id="element-1100">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1101" />
                  <span data-id="element-1102">Carry cash (NPR) - ATMs limited outside cities</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1103">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1104" />
                  <span data-id="element-1105">Dress modestly when visiting temples</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1106">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1107" />
                  <span data-id="element-1108">Bargain politely in markets (except restaurants)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1109">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1110" />
                  <span data-id="element-1111">Drink only bottled or purified water</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl" data-id="element-1112">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1113">
                <Check className="text-green-600" size={20} data-id="element-1114" />
                Cultural Etiquette
              </h4>
              <ul className="space-y-2 text-gray-700 text-sm" data-id="element-1115">
                <li className="flex items-start gap-2" data-id="element-1116">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1117" />
                  <span data-id="element-1118">Remove shoes before entering homes and temples</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1119">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1120" />
                  <span data-id="element-1121">Use right hand for eating and giving/receiving</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1122">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1123" />
                  <span data-id="element-1124">Ask permission before photographing people</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1125">
                  <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-1126" />
                  <span data-id="element-1127">Walk clockwise around Buddhist stupas</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Popular Treks */}
        <section className="mb-20" data-id="element-1128">
          <SectionHeading title="Popular Treks in Nepal" subtitle="Explore the best trekking routes this destination has to offer." data-id="element-1129" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1130">
            {popularTreks.map((trek, index) => <motion.a key={index} href={trek.link} target={trek.link.startsWith('http') ? '_blank' : '_self'} rel={trek.link.startsWith('http') ? 'noopener noreferrer' : undefined} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all" data-id="element-1131">
                <div className="relative h-64 overflow-hidden" data-id="element-1132">
                  <img src={trek.image} alt={trek.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-1133" />
                </div>
                <div className="p-6" data-id="element-1134">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1135">
                    {trek.title}
                  </h3>
                  <div className="flex items-center justify-between text-sm text-gray-600 mb-4" data-id="element-1136">
                    <span data-id="element-1137">{trek.duration}</span>
                    <span className="text-orange-600 font-semibold" data-id="element-1138">
                      {trek.difficulty}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1139">
                    <span className="text-2xl font-bold text-[#0066FF]" data-id="element-1140">
                      {trek.price}
                    </span>
                    <span className="text-[#0066FF] font-medium flex items-center gap-2 group-hover:gap-3 transition-all" data-id="element-1141">
                      View Trek <ArrowRight size={16} data-id="element-1142" />
                    </span>
                  </div>
                </div>
              </motion.a>)}
          </div>
        </section>

        {/* CTA */}
        <section className="bg-gradient-to-r from-[#0066FF] to-[#06B6D4] rounded-2xl p-12 text-center text-white" data-id="element-1143">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1144">
            Ready to Explore Nepal?
          </h2>
          <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto" data-id="element-1145">
            Let us help you plan the perfect Nepalese adventure. From trekking
            to cultural tours, we'll create an unforgettable experience.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1146">
            <Button variant="primary" size="lg" className="bg-white text-[#0066FF] hover:bg-gray-100 border-none" data-id="element-1147">
              View All Nepal Treks
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-[#0066FF]" data-id="element-1148">
              Contact Us
            </Button>
          </div>
        </section>
      </main>

      <Footer data-id="element-1149" />
    </div>;
}